import React from 'react';
import { dummyClick } from '../../utilities';

const IconButton = ({ icon, width, height, className, onClick }) => (
  <button className={`dib bg-transparent bn pointer t-pv0 ${className}`} onClick={onClick}>
    <img src={icon} className="dib grow" width={width} height={height} />
  </button>
);

IconButton.defaultProps = {
  icon: '/images/pop-like-icon.svg',
  width: '46px',
  height: '46px',
  className: '',
  onClick: dummyClick
};

export default IconButton;
